import { createConfigParametersRepository } from '../../configParametersRepository';
import { PAGE_RENDER_ID } from '../pageRenderID';

export const getPageRenderId = async () => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const pageRenderId = await storageClient?.getNonTechnicalFromStorage(
    'sessionStorage',
    PAGE_RENDER_ID,
    null
  );
  return pageRenderId || window?.__htmlEvents__?.pageRenderId;
};
